import { render, staticRenderFns } from "./prospects.vue?vue&type=template&id=7ded83a6&scoped=true&"
import script from "./prospects.vue?vue&type=script&lang=js&"
export * from "./prospects.vue?vue&type=script&lang=js&"
import style0 from "./prospects.vue?vue&type=style&index=0&id=7ded83a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ded83a6",
  null
  
)

export default component.exports